import { MultiSelect } from '@creditornot/cb-select';
import { Tag } from '@creditornot/cb-tag';
import React, { useMemo } from 'react';
import { Field, useFormState } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import { BaseField } from './types';
import { dietaryPreferenceTranslationMap } from '../../../constants';
import { useProductOverridesContext } from '../../../context/ProductOverridesContext';
import { FormRowRenderer } from '../FormRowRenderer';
import { StyledInputContainer } from '../OfferDetailsFormFields.styles';
import { AdvancedDetails, FormValues } from '../types';
import { getDietaryPreferenceOptions } from '../utils';

export const DietaryPreferences = ({ sidePanelMode, offer }: BaseField) => {
  const menuPermissions = useOfferingMenuPermissionsContext();
  const { values } = useFormState<FormValues>();
  const intl = useIntl();
  const { isAttrConnectedToProduct } = useProductOverridesContext();

  const dietaryPreferenceOptions = useMemo(() => getDietaryPreferenceOptions(intl.formatMessage), [intl]);

  const previewComponent = !!offer?.dietary_preferences?.length ? (
    <div style={{ margin: '-4px 0' }}>
      {offer.dietary_preferences.map(type => (
        <Tag key={type} variant="lightBlue" size="small" style={{ margin: '4px 8px 4px 0' }}>
          <FormattedMessage id={dietaryPreferenceTranslationMap[type]} />
        </Tag>
      ))}
    </div>
  ) : (
    '-'
  );

  const editComponent = (
    <Field<AdvancedDetails['dietaryPreferences']> name="dietaryPreferences">
      {field => (
        <StyledInputContainer>
          <MultiSelect
            {...field.input}
            options={dietaryPreferenceOptions}
            disabled={isAttrConnectedToProduct('dietaryPreferences')}
          />
        </StyledInputContainer>
      )}
    </Field>
  );

  return (
    <FormRowRenderer
      hasContentEditPermission={menuPermissions.contentEdit}
      label={intl.formatMessage({ id: 'menu.dietaryPreferences.title' })}
      previewComponent={previewComponent}
      editComponent={editComponent}
      shouldDisplayCreateTag={!values.dietaryPreferences?.length}
      sidePanelMode={sidePanelMode}
      offer={offer}
      catalogName="dietaryPreferences"
    />
  );
};
